import { ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { TableComponent } from '../../../components/table/table.component';
import { MatExpansionPanel } from '@angular/material/expansion';
import { Router } from '@angular/router';
import { AlertaService } from '../../../services/alerta.service';
import { tableModel } from '../../../components/table/model/tableModel';
import { FilterCostsPerEmployeeCatalog } from '../../../models/filters/filter-costs-per-employee-catalog';
import { CostsPerEmployeeCatalogService } from '../../../services/costs-per-employee-catalog.service';


@Component({
  selector: 'app-cost-per-employee',
  standalone: false,
  templateUrl: './cost-per-employee.component.html',
  styleUrl: './cost-per-employee.component.css'
})
export class CostPerEmployeeComponent {

  @ViewChild(TableComponent) costsPerEmployeesCatalogTable:TableComponent| undefined;
  @ViewChild('advancedPanel') advancedPanel!: MatExpansionPanel;

  tableModel: tableModel= {
    columnModel:[
      {columnName:'#',columnValue:'id'},
      {columnName:'Descripción',columnValue:'description'},
      {columnName:'Codigo',columnValue:'attribute'},
      {columnName:'Tipo Beneficio',columnValue:'costsPerEmployeeTypeDes'}
    ],
    dataSource:[],
    editButton:true
  };

  pageIndex: number = 1;
  pageSize: number = 5;
  loading: boolean = false;
  filterCostsPerEmployeeCatalog: FilterCostsPerEmployeeCatalog = new FilterCostsPerEmployeeCatalog;
  advancedSearch: boolean = false;
  
  private costsPerEmployeeCatalogService = inject(CostsPerEmployeeCatalogService);
  router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private alerta = inject(AlertaService);

  ngOnInit(): void {
    this.filterCostsPerEmployeeCatalog = new FilterCostsPerEmployeeCatalog();
    this.searchCostsPerEmployeeGroupPaginator();
  }
  paginatorEvent(event: any){
    this.pageIndex = (event.pageIndex+1);
    this.pageSize = event.pageSize;
    this.searchCostsPerEmployeeGroupPaginator();
  }

  editEvent(event: any){
    this.router.navigate(['/costsPerEmployeesCatalog/edit', event.id]);
  }
  addNewCostsPerEmployeeGroup(){
    this.router.navigate(['/costsPerEmployeesCatalog/edit', 0]);
  }

  searchCostsPerEmployeeGroupPaginatorAS(){
    this.pageIndex = 1;
    this.advancedSearch = true;
    this.searchCostsPerEmployeeGroupPaginator();
  }

  searchCostsPerEmployeeGroupPaginator(){
    this.loading = true;

    this.costsPerEmployeeCatalogService.findAllPageableCostsPerEmployeeCatalog(this.filterCostsPerEmployeeCatalog, this.pageIndex, this.pageSize).subscribe({
      next: (pageable) => {
        this.tableModel.pageSize = pageable.pageSize;
        this.tableModel.totalRecords = pageable.itemsCount;
        this.tableModel.dataSource = pageable.list;
        this.tableModel.pageNumber = pageable.pageNum;
        
        setTimeout(() => {
          this.costsPerEmployeesCatalogTable?.refresh(pageable.list, pageable.itemsCount);
        });
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        if(err.status == 400){
          this.alerta.error("Se ha terminado el tiempo de session: ", {detail: err.message});
          this.router.navigate(['/login']);
        }else{
          this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
        }
      }
    });

    if(this.advancedPanel != null){
      if (this.advancedSearch) {
        this.advancedPanel.open();
      } else {
        this.advancedPanel.close();
      }
    }
  }
}
